import { createShortUid, logError } from '@amazon/vinyl-util'
import type { PlaylistEntry } from '@/playback/PlaylistController'
import type { AdvertisementFields } from '@/service/fragments/advertisementFieldsFrag'
import { ctx } from '@/util/context'

const { target } = ctx('advertisementToPlaylistEntry')

/** A free-tier queue's audio ad, played off its own url like any other queue entry. */
export function advertisementToPlaylistEntry(ad: AdvertisementFields): PlaylistEntry | null {
    const audioUrl = ad.playbackInformation?.audioUrl
    if (!audioUrl) {
        logError(target, 'advertisement missing audioUrl', ad.id)
        return null
    }
    return {
        id: ad.id ?? createShortUid(),
        entity: ad,
        title: ad.name ?? '',
        albumTitle: '',
        artistName: '',
        duration: 0,
        image: ad.image,
        trackLoadOptions: { type: 'src', uri: audioUrl },
    }
}
